
import SquareController from '@/types/SquareController'
import LocalStats from '@/types/LocalStats'
import { defineComponent, PropType } from 'vue'
import QDialog from 'quasar/src/components/dialog/QDialog.js';import QCard from 'quasar/src/components/card/QCard.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';
import LocalStatsItem from './LocalStatsItem.vue';
import WinsDistributionGraph from './WinsDistributionGraph.vue';
import ShareInfoDialog from './ShareInfoDialog.vue';
import { LSKeys } from '@/assets/constants';

export default defineComponent({
    components: {
        QDialog,
        QCard,
        QBtn,
        LocalStatsItem,
        WinsDistributionGraph,
        QSeparator,
        QCardSection,
    },
    emits: [
        ...useDialogPluginComponent.emits,
    ],
    setup() {
        const { dialogRef, onDialogHide } = useDialogPluginComponent();
        return { dialogRef, onDialogHide };
    },
    props: {
        squareController: {
            required: true,
            type: Object as PropType<SquareController>,
        },
        localStats: {
            required: true,
            type: Object as PropType<LocalStats>,
        },
    },
    computed: {
        showShare() {
            return this.squareController.isFinished;
        },
        winsPercentage() {
            let value = this.localStats.amountOfWins/this.localStats.amountOfGames;
            if (isNaN(value)) value = 0;
            value *= 100;
            return `${value.toFixed(1)}%`;
        }
    },
    methods: {
        hide() {
            this.dialogRef?.hide();
        },
        share() {
            copyToClipboard(this.squareController.colorRanking.getShareText({
                gameUrl: 'palavra-quadrada.web.app',
                gameNumber: this.squareController.gameNumber,
                triesNeeded: this.squareController.triesNeeded,
            }))
                .then(() => this.$q.notify('Texto copiado'))
                .catch(() => this.$q.notify('Algo deu errado'))
            const hasSeenShareInfo = localStorage.getItem(LSKeys.hasSeenShareInfo);
            if (!hasSeenShareInfo || !JSON.parse(hasSeenShareInfo)) {
                this.showShareInfoDialog();
                localStorage.setItem(LSKeys.hasSeenShareInfo, JSON.stringify(true));
            }
        },
        showShareInfoDialog() {
            this.$q.dialog({
                component: ShareInfoDialog,
                componentProps: {
                    squareEmojis: this.squareController.colorRanking.getBoardRanking(
                        this.squareController.triesNeeded,
                    )
                }
            });
        },
    }
})
